import styled from 'styled-components';
import media from 'styled-media-query';
import { AccountSubscriptionLpDeal } from '../../organisms/lp/accountSubscription/AccountSubscriptionLpDeal';
import { LpPlan } from '../../organisms/lp/LpPlan';
import { AccountSubscriptionLpCampaign } from '../../organisms/lp/accountSubscription/AccountSubscriptionLpCampaign';
import { SubscriptionLayout } from '../../templates/SubscriptionLayout';
import { LpFooter } from '../../organisms/lp/LpFooter';
import { LOWER_META_TITLE } from '../../../const/Service';
import { LpFeature } from '../../organisms/lp/LpFeature';
import { useGoogleFonts } from '../../../common/customHooks/GoogleFonts';
import { AccountSubscriptionLpFvContent } from '../../molecules/lp/accountSubscription/AccountSubscriptionLpFvContent';
import { useRef } from 'react';

const metaTitle = `加入プラン | ${LOWER_META_TITLE}`;

export const AccountSubscriptionLp: React.FC = (): JSX.Element => {
  const { onClickCv, planRef } = useAccountSubscriptionLp();

  return (
    <SubscriptionLayout metaTitle={metaTitle} onClickCv={onClickCv}>
      <AccountSubscriptionLpFvContent onClickCV={onClickCv} />
      <AccountSubscriptionLpCampaign onClickCV={onClickCv} subscription />
      <LpFeature title={'有料プランの特徴'} />
      <AccountSubscriptionLpDeal />
      <AccountSubscriptionLpCampaign onClickCV={onClickCv} subscription />
      <LpPlan ref={planRef} type="recontract" isSubscription />
      <FooterWrapper>
        <LpFooter />
      </FooterWrapper>
    </SubscriptionLayout>
  );
};

const useAccountSubscriptionLp = () => {
  const planRef = useRef<HTMLDivElement>(null);
  const onClickCv = () => {
    // ヘッダーで隠れない位置にスクロール
    const rect = planRef.current?.getBoundingClientRect();
    const top = window.scrollY + rect!.top - 90;
    window.scrollTo({ top, behavior: 'smooth' });
  };
  useGoogleFonts();

  return { onClickCv, planRef };
};

const FooterWrapper = styled.div`
  margin-top: 3rem;
  ${media.lessThan('medium')`
    margin-top: 0;
  `}
`;
